import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import { getOperatorLabel } from 'modules/reports/lib/operatorLabels'

import transformArguments from './argumentMatchers'

interface Props {
  fieldType: FieldType
}

const FilteringInfo = ({ fieldType }: Props) => {
  const { form, field } = fieldType
  const operator = form.get('operator').value

  if (!operator) return null

  if (!field) return null

  const label = getOperatorLabel(field.attributes.type, operator)
  const values = transformArguments(fieldType)

  return (
    <Box flexDirection="row">
      <Text.Normal color="grey1000" size="200" weight="medium">
        {label}
        {!!values && ':'}&nbsp;
      </Text.Normal>
      <Text.Normal color="grey1000" size="200">
        {values}
      </Text.Normal>
    </Box>
  )
}

export default observer(FilteringInfo)
